import React from 'react';

export const PROPOSAL_STATUS_LABELS = {
  draft: 'Draft',
  for_review: 'For Review',
  sent_to_client: 'Sent to Client',
  signed: 'Signed',
  rejected: 'Rejected'
};

export const getProposalStatusColor = (status) => {
  const colors = {
    draft: 'bg-muted text-foreground',
    for_review: 'bg-yellow-500/20 text-yellow-600',
    sent_to_client: 'bg-blue-500/20 text-blue-600',
    signed: 'bg-emerald-500/20 text-emerald-700',
    rejected: 'bg-destructive/20 text-destructive'
  };
  return colors[status] || 'bg-muted';
};

export const ProposalStatusBadge = ({ status }) => (
  <span className={`px-2.5 py-0.5 text-xs font-semibold rounded-full ${getProposalStatusColor(status)}`}>
    {PROPOSAL_STATUS_LABELS[status] || status.replace('_', ' ')}
  </span>
);
